<template>
    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">Tribinnov Capital</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-details detail-section">
            <div class="container">
                <div class="row">

                    <div class="col-12">
                        <div class="details-content">
                            <div class="text">
                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>
                                        This is a an Angel Network cum VC Fund which is we plan to launch by 2023.
                                        However, before 2023, this is presently manifested in two ways:
                                    </p>
                                    <ul class="list">
                                        <li>
                                            partnership with organizations to fund StartUps are Seed and Series A rounds
                                            both as a Pipeline and Incubation platform.
                                        </li>
                                        <li>
                                            Partnership with Global Crowdfunding Platforms to raise funds for Promising
                                            Startups within our ecosystem
                                        </li>
                                    </ul>
                                </div>
                                <p>
                                    The final goal of Tribinnov Capital is to commence with a $10-$30 million fund.
                                    Want to join our waitlist ?
                                </p>
                                <div class="button my-5" style="text-align: center;">
                                    <a href="https://app.tribinnovafrica.com" target="_blank" class="btn">Join The
                                        Waitlist<i class="lni lni-arrow-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TribinnovCapital',
        metaInfo: {
            title: "Tribinnov Africa - Tribinnov Capital",
            meta: [
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>